export default __webpack_public_path__ + "static/media/pictogramBeaconFeedback48.3f1abdb6.svg";